import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "MenuSmall",
  "use": "MenuSmall-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"MenuSmall\">\n  <path d=\"M9 24h18v-2H9v2Zm0-5h18v-2H9v2Zm0-7v2h18v-2H9Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol